import type { AppLink } from '@sectepe/ui';

/**
 * Kuratierte Liste der Suite-Apps fuer den App-Switcher (Waffle) im Top-Bar —
 * das M365-App-Launcher- / Google-9-Punkte-Aequivalent.
 *
 * Die Konsole hat keine zur Build-Zeit bekannten absoluten Service-URLs (die
 * webui-Shell injiziert sie zur Laufzeit ueber externalUrls). Deshalb verweist
 * der erste Eintrag auf den Suite-Hub ("/" der webui), und die uebrigen
 * Eintraege nutzen die kanonischen, relativen Subpfade des Reverse-Proxy.
 * Wir erfinden KEINE neuen Backends — nur Links auf bestehende Oberflaechen.
 *
 * `target="_blank"` erreichen wir hier nicht (AppLink rendert ein <a> ohne
 * target); die Links navigieren same-tab, was fuer den Wechsel in eine andere
 * Suite-App das erwartete Verhalten ist.
 */
export const SUITE_APPS: AppLink[] = [
  { id: 'home', label: 'Suite-Start', href: '/', icon: '🏠' },
  { id: 'mail', label: 'E-Mail', href: '/mail', icon: '✉️' },
  { id: 'chat', label: 'Chat', href: '/chat', icon: '💬' },
  { id: 'video', label: 'Video', href: '/video', icon: '🎥' },
  { id: 'files', label: 'Dateien', href: '/files', icon: '📁' },
  { id: 'security', label: 'Security', href: '/security', icon: '🛡️' },
  { id: 'monitoring', label: 'Monitoring', href: '/monitoring', icon: '📈' },
];
